'use strict';

var _micromodal = require('micromodal');

var _micromodal2 = _interopRequireDefault(_micromodal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*-------------------------
Modals
-------------------------*/

document.addEventListener('DOMContentLoaded', function (event) {
  _micromodal2.default.init({
    awaitCloseAnimation: true,
    disableScroll: true
  });

  window.MicroModal = _micromodal2.default;
});